import React, { useEffect, useState } from 'react';
import './OrbitSwap.css';

const LINE = 1.25;

const OrbitSwap = ({ className = '', phrases = [] }) => {
  const list = phrases.filter(Boolean);
  const reel = list.length > 1 ? [...list, list[0]] : list;
  const [index, setIndex] = useState(0);
  const [animate, setAnimate] = useState(true);

  useEffect(() => {
    if (list.length < 2) return undefined;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const id = setInterval(() => {
      setAnimate(true);
      setIndex((current) => (current >= list.length ? current : current + 1));
    }, 2800);
    return () => clearInterval(id);
  }, [list.length]);

  useEffect(() => {
    if (animate || index !== 0) return undefined;
    const id = requestAnimationFrame(() => setAnimate(true));
    return () => cancelAnimationFrame(id);
  }, [animate, index]);

  const onTransitionEnd = () => {
    if (list.length > 1 && index === list.length) {
      setAnimate(false);
      setIndex(0);
    }
  };

  return (
    <span className={`orbit-swap-host${className ? ` ${className}` : ''}`}>
      <span className="orbit-swap" aria-hidden="true">
        <i />
        <i />
        <i />
      </span>
      {reel.length > 0 ? (
        <span className="orbit-swap-window" style={{ height: `${LINE}em` }} aria-hidden="true">
          <span
            className={`orbit-swap-track${animate ? '' : ' is-instant'}`}
            style={{ transform: `translateY(calc(-${index} * ${LINE}em))` }}
            onTransitionEnd={onTransitionEnd}
          >
            {reel.map((phrase, line) => (
              <span className="orbit-swap-line" key={`${phrase}-${line}`} style={{ height: `${LINE}em` }}>
                {[...phrase].map((char, i) => (
                  <span key={i} style={{ animationDelay: `${i * 0.08}s` }}>
                    {char === ' ' ? '\u00a0' : char}
                  </span>
                ))}
              </span>
            ))}
          </span>
        </span>
      ) : null}
    </span>
  );
};

export default OrbitSwap;
